var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"}})}
var staticRenderFns = []

export { render, staticRenderFns }